import { Box, Tabs, Tab, FormControl, InputLabel, OutlinedInput, InputAdornment } from '@mui/material';
import { makeStyles } from "@mui/styles";
import Text from 'components/common/Text';
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import EventIcon from '@mui/icons-material/Event';
import Dialog from 'components/common/Dialog';
import DatePickerModal from 'components/common/DatePickerModal';
import LeadsList from './LeadsList';
import * as XLSX from 'xlsx';
import HostLIstData from './HostLIstData';
import OwnerListData from './OwnerListData';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import Button from 'components/common/Button';
import Grid from 'components/common/Grid';
import Paper from 'components/common/Paper';

const useStyles = makeStyles((theme) => ({
  table_date: {
    "@media (max-width:768px)": {
      width: "218%",
    },
  },

  category_btn: {
    padding:"10px 25px",
    fontSize: "14px",
    float:'right',
    border: "1px solid #19AA69",
    borderRadius: "30px",
    "@media (max-width:768px)": {
      marginTop: "12px",
    },
  },
}));

const Leads = ({
  onChange,
  lead_data,
  host_data,
  datePickerOpen,
  handleDatePickerOpen,
  handleDatePickerClose,
  from_date,
  to_date,
  owner_data,
  fromat_date_from,
  fromat_date_to,
  onDatePickerSub,
  handleTabChange,
  value,
  handleReset
}) => {
  const classes = useStyles();

  const downloadAsExcel = () => {
    let dataToDownload = [];

    if (value === '1') {
      dataToDownload = lead_data;
    } else if (value === '2') {
      dataToDownload = owner_data;
    } else if (value === '3') {
      dataToDownload = host_data;
    }

    if (dataToDownload.length === 0) {
      return;
    }

    const worksheet = XLSX.utils.json_to_sheet(dataToDownload);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Data');
    XLSX.writeFile(workbook, 'DataSheet.xlsx');
  };

  return (
    <Grid container>
          <Grid item xs={12} lg={12}>
            <Paper sx={{ p: 3, mt: 3.5, marginLeft: "5px"}}>
          <Text
            variant="h5"
            color="#707070"
            sx={{ fontSize: "22px", marginBottom: "40px" }}
          >
            LEADS
          </Text>
          <Button onClick={downloadAsExcel}  className={classes.category_btn}
                  variant="contained"
                  color="primary">Download <FileDownloadIcon/></Button>

          <Box sx={{ maxWidth: 200, minWidth: 200 }}>
            <FormControl fullWidth size="small">
              <InputLabel
                sx={{ fontSize: "13px", marginLeft: "-5px" }}
                id="daterange-label"
              >
                Date Range
              </InputLabel>
              <OutlinedInput
                label="Date Range"
                className={classes.table_date}
                sx={{ fontSize: "10px", height: "37px", fontWeight: "600" }}
                id="outlined-adornment-amount"
                value={
                  fromat_date_from && fromat_date_to
                    ? `${fromat_date_from} - ${fromat_date_to}`
                    : ""
                }
                onClick={handleDatePickerOpen}
                endAdornment={
                  <InputAdornment position="end" sx={{cursor:'pointer'}}>
                    <EventIcon />
                  </InputAdornment>
                }
              />
            </FormControl>
            <div>

            </div>

          </Box>
          <Dialog
            open={datePickerOpen !== undefined ? datePickerOpen : false}
            onClose={handleDatePickerClose}
            title="Select a date range"
            children={
              <DatePickerModal
                onClose={handleDatePickerClose}
                onDatePickerSub={onDatePickerSub}
                from_date={from_date}
                to_date={to_date}
                handleChange={onChange}
                handleReset={handleReset}
              />
            }
          />
          <TabContext value={value}>
            <Box sx={{ borderBottom: 1, borderColor: "divider", marginTop: 3 }}>
              <Tabs
                value={value}
                onChange={handleTabChange}
                aria-label="lab API tabs example"
              >
                <Tab label="Landing Page Query" sx={{ textTransform: "none" }} value="1" />
                <Tab label="EV Owner Query" sx={{ textTransform: "none" }} value="2" />
                <Tab label="Station Owner Query" sx={{ textTransform: "none" }} value="3" />
              </Tabs>
            </Box>
            <TabPanel value="1">
              <LeadsList
                data={lead_data}
              />
            </TabPanel>
            <TabPanel value="2">
              <OwnerListData
                data={owner_data}
              />
            </TabPanel>
            <TabPanel value="3">
              <HostLIstData
                data={host_data} />
            </TabPanel>
          </TabContext>
          </Paper>
          </Grid>
        </Grid>
  );
};

export default Leads;
